import { useEffect } from 'react'
import { useSearchParams } from 'react-router'

import { APPLICANTS_FILTER_PARAM } from '../../../../RentalPortalApplicant'

import { APPLICANTS_VIEW_PARAM } from './useRentalPortalApplicantsViewRegime.constants'
import {
  getApplicantsTableViewRegime,
  getApplicantsViewRegime,
} from './useRentalPortalApplicantsViewRegime.utils'

export function useRentalPortalApplicantsViewRegime({
  filterValues,
  handleSetFilterValues,
  hasStage,
  isCompareAvailable,
}) {
  const [searchParams, setSearchParams] = useSearchParams()

  const listViewType = getApplicantsViewRegime({
    hasStage,
    isCompareAvailable,
    searchParams,
  })

  function handleSetListViewType(view) {
    setSearchParams(
      params => {
        params.set(APPLICANTS_VIEW_PARAM, view)

        return params
      },
      { replace: true }
    )
  }

  useEffect(() => {
    if (
      searchParams.has(APPLICANTS_VIEW_PARAM) &&
      searchParams.get(APPLICANTS_VIEW_PARAM) !== listViewType
    ) {
      handleSetListViewType(listViewType)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- `handleSetListViewType` is re-created every render and must not re-run the normalisation
  }, [listViewType, searchParams])

  function handleShowStageInTable(stage) {
    handleSetFilterValues(
      { ...filterValues, [APPLICANTS_FILTER_PARAM.stage]: stage },
      { [APPLICANTS_VIEW_PARAM]: getApplicantsTableViewRegime(listViewType) }
    )
  }

  return { handleSetListViewType, handleShowStageInTable, listViewType }
}
